<template>
  <ul class="info-list">
    <li class="info-item">
      <span class="info-item__title">學制</span>
      <span class="info-item__content">{{profile.schoolSystems}}</span>
    </li>
    <li class="info-item">
      <span class="info-item__title">科目</span>
      <span class="info-item__content">{{profile.subjects}}</span>
    </li>
    <li class="info-item">
      <span class="info-item__title">教學經歷</span>
      <ul>
        <li :key="index" v-for="(exp, index) in profile.experience" class="mb-2">
          {{exp}}
        </li>
      </ul>
    </li>
    <li class="info-item info-item--self-intro">
      <h6 class="info-item__title mb-3">個人介紹</h6>
      <p class="self-intro subheading">{{profile.intro}}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    profile: {
      type: Object
    }
  }
};
</script>

<style lang="stylus" scoped>

.info-list {
  width: 100%;
  padding-left: 0;
}

.info-item {
  display: flex;
  align-items: stretch;
  padding: 1rem;
  min-width: 320px;
  flex-grow: 1;

  &:hover {
    // background-color: $def-hover-color;
  }
}

.info-item__title {
  font-size: 1.1rem;
  margin-right: auto;
  color: rgba(0,0,0,0.8);
}

.info-item__content {
  max-width: 50%;
  text-align: right;
}

.info-item ~ .info-item {
  border-top: 1px solid rgba(0,0,0,0.12);
}

.info-item--self-intro {
  flex-direction: column;
}
</style>
